module.exports = __webpack_public_path__ + "static/media/icon_104.142e8bd5.svg";